var plugins = [{
      name: 'gatsby-plugin-react-helmet',
      plugin: require('/var/www/wasif.dev.jt.hostingshouse.com/public_html/scripts/redoc-devel/node_modules/gatsby-plugin-react-helmet/gatsby-ssr'),
      options: {"plugins":[]},
    },{
      name: 'gatsby-plugin-layout',
      plugin: require('/var/www/wasif.dev.jt.hostingshouse.com/public_html/scripts/redoc-devel/node_modules/gatsby-plugin-layout/gatsby-ssr'),
      options: {"plugins":[]},
    },{
      name: 'gatsby-remark-autolink-headers',
      plugin: require('/var/www/wasif.dev.jt.hostingshouse.com/public_html/scripts/redoc-devel/node_modules/@redocly/developer-portal/dist/engine/plugins/gatsby-remark-autolink-headers/gatsby-ssr'),
      options: {"plugins":[]},
    },{
      name: 'gatsby-plugin-styled-components',
      plugin: require('/var/www/wasif.dev.jt.hostingshouse.com/public_html/scripts/redoc-devel/node_modules/gatsby-plugin-styled-components/gatsby-ssr'),
      options: {"plugins":[],"displayName":true,"fileName":true,"minify":true,"namespace":"","transpileTemplateLiterals":true,"topLevelImportPaths":[],"pure":false},
    },{
      name: 'gatsby-plugin-manifest',
      plugin: require('/var/www/wasif.dev.jt.hostingshouse.com/public_html/scripts/redoc-devel/node_modules/gatsby-plugin-manifest/gatsby-ssr'),
      options: {"plugins":[],"icon":"/var/www/wasif.dev.jt.hostingshouse.com/public_html/scripts/redoc-devel/favicon.png","name":"Redocly Training","legacy":true,"theme_color_in_head":true,"cache_busting_mode":"query","crossOrigin":"anonymous","include_favicon":true,"cacheDigest":"eeb6c2ffa08b8a3b258c82c9e1c1a8a6"},
    },{
      name: 'gatsby-plugin-sitemap',
      plugin: require('/var/www/wasif.dev.jt.hostingshouse.com/public_html/scripts/redoc-devel/node_modules/gatsby-plugin-sitemap/gatsby-ssr'),
      options: {"plugins":[],"output":"/sitemap.xml","createLinkInHead":true},
    },{
      name: 'gatsby-plugin-canonical-urls',
      plugin: require('/var/www/wasif.dev.jt.hostingshouse.com/public_html/scripts/redoc-devel/node_modules/gatsby-plugin-canonical-urls/gatsby-ssr'),
      options: {"plugins":[],"siteUrl":"https://portal-demo.redoc.ly"},
    }]
// During bootstrap, we write requires at top of this file which looks like:
// var plugins = [
//   {
//     plugin: require("/path/to/plugin1/gatsby-ssr.js"),
//     options: { ... },
//   },
//   {
//     plugin: require("/path/to/plugin2/gatsby-ssr.js"),
//     options: { ... },
//   },
// ]

const apis = require(`./api-ssr-docs`)

// Run the specified API in any plugins that have implemented it
module.exports = (api, args, defaultReturn, argTransform) => {
  if (!apis[api]) {
    console.log(`This API doesn't exist`, api)
  }

  // Run each plugin in series.
  // eslint-disable-next-line no-undef
  let results = plugins.map(plugin => {
    if (!plugin.plugin[api]) {
      return undefined
    }
    try {
      const result = plugin.plugin[api](args, plugin.options)
      if (result && argTransform) {
        args = argTransform({ args, result })
      }
      return result
    } catch (e) {
      if (plugin.name !== `default-site-plugin`) {
        // default-site-plugin is user code and will print proper stack trace,
        // so no point in annotating error message pointing out which plugin is root of the problem
        e.message += ` (from plugin: ${plugin.name})`
      }

      throw e
    }
  })

  // Filter out undefined results.
  results = results.filter(result => typeof result !== `undefined`)

  if (results.length > 0) {
    return results
  } else {
    return [defaultReturn]
  }
}
